import React, { useCallback, useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { getAdsConfiguration } from "store/slices";
import { AppDispatch } from "store/store";
import { selectAdsConfigurations } from "store/select";
import { DataTable, PageTitle } from "components";
import { SortModel, AdsConfigurationFilters, AdsConfiguration } from "types";
import { defaultPageNumber, defaultRowsPerPage } from "constant";
import { getColumns } from "./columns";

const columns = getColumns();

export const AdsConfigurations = () => {
  const [filter, setFilter] = useState<AdsConfigurationFilters>({});
  const [sort, setSortModel] = useState<SortModel>([]);
  const [perPage, setPerPage] = useState(defaultRowsPerPage);
  const [pageNumber, setPageNumber] = useState(defaultPageNumber);
  const { data, loading, totalCount } = useSelector(selectAdsConfigurations);
  const dispatch = useDispatch<AppDispatch>();

  const onPageSizeChange = useCallback((newPerPage: number) => {
    setPerPage(newPerPage);
    setPageNumber(defaultPageNumber);
  }, []);

  const onPageChange = useCallback((newPage: number) => {
    setPageNumber(newPage);
  }, []);

  useEffect(() => {
    dispatch(getAdsConfiguration({ pageNumber, perPage, sort, ...filter }));
  }, [pageNumber, perPage, sort, filter, dispatch]);

  return (
    <>
      <PageTitle title="Ads Configurations" />
      <DataTable<AdsConfiguration, AdsConfigurationFilters>
        data={data}
        sort={sort}
        columns={columns}
        loading={loading}
        perPage={perPage}
        pageNumber={pageNumber}
        totalCount={totalCount}
        onPageChange={onPageChange}
        onPageSizeChange={onPageSizeChange}
        onSortChange={setSortModel}
        enableColumnResizing
        filters={filter}
        onFilterChange={setFilter}
        columnResizeMode="onChange"
      />
    </>
  );
};
